import { render, staticRenderFns } from "./FoldCard.vue?vue&type=template&id=79eed60e&scoped=true&"
import script from "./FoldCard.vue?vue&type=script&lang=js&"
export * from "./FoldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eed60e",
  null
  
)

export default component.exports